<div class="pw-page">
  <div class="pw-logo" role="heading" aria-level="1">Setting Up Your<span> Profile</span></div>

  <div class="pw-wizard">
    <!-- Progress bar -->
    <div
      class="pw-steps-bar"
      role="progressbar"
      aria-label="Profile setup progress"
      [attr.aria-valuenow]="currentStep"
      aria-valuemin="1"
      [attr.aria-valuemax]="steps.length"
    >
      @for (s of steps; track s; let i = $index) {
        <div
          class="pw-seg"
          [class.done]="i + 1 < currentStep"
          [class.active]="i + 1 === currentStep"
          aria-hidden="true"
        ></div>
      }
    </div>

    <div class="pw-body" aria-live="polite" aria-atomic="true">
      <!-- Step 1: Name + Grade -->
      <div class="pw-panel" *ngIf="currentStep === 1">
        <div class="pw-step-label" aria-hidden="true">Step 1 of 4</div>
        <h2 class="pw-step-title">What's your preferred name?</h2>
        <p class="pw-step-sub">
          This is how you'll appear on your Handle profile — your name plus your career goal once
          you set it. For example: <em>Anna Kolb (future Software Engineer)</em>.
        </p>
        <label class="pw-field-label" for="preferredNameInput">Preferred name</label>
        <input
          id="preferredNameInput"
          class="pw-field"
          type="text"
          placeholder="e.g. Anna"
          [(ngModel)]="profile.preferredName"
          aria-label="Preferred name"
        />
      </div>

      <!-- Step 3: Career goal -->
      <div class="pw-panel" *ngIf="currentStep === 2">
        <div class="pw-step-label" aria-hidden="true">Step 2 of 4</div>
        <h2 class="pw-step-title">What's your career goal?</h2>
        <p class="pw-step-sub">
          Pick the field that excites you most. This powers your career avatar and personalizes your
          experience.
        </p>
        <div class="pw-career-grid" role="list" aria-label="Career goal options">
          <button
            class="pw-career-btn"
            *ngFor="let c of careers"
            [class.selected]="profile.careerId === c.id"
            (click)="profile.careerId = c.id"
            role="listitem"
            [attr.aria-pressed]="profile.careerId === c.id"
            [attr.aria-label]="'Select career goal: ' + c.label"
          >
            <span class="pw-career-icon" aria-hidden="true">{{ c.icon }}</span>
            {{ c.label }}
          </button>
        </div>
      </div>

      <!-- Step 4: Interests -->
      <div class="pw-panel" *ngIf="currentStep === 3">
        <div class="pw-step-label" aria-hidden="true">Step 3 of 4</div>
        <h2 class="pw-step-title">What are your interests?</h2>
        <p class="pw-step-sub">
          Select everything that applies. We'll use this to personalize your feed and suggestions.
        </p>
        <div class="pw-interest-grid" role="list" aria-label="Interest selection">
          @for (interest of interests; track interest) {
            <button
              class="pw-interest-btn"
              [class.selected]="profile.interests.includes(interest)"
              (click)="toggleInterest(interest)"
              [attr.aria-pressed]="profile.interests.includes(interest)"
              [attr.aria-label]="'Toggle interest: ' + interest.name"
              role="listitem"
            >
              {{ interest.name }}
            </button>
          }
        </div>
      </div>

      <!-- Step 5: Photo -->
      <div class="pw-panel" *ngIf="currentStep === 4">
        <div class="pw-step-label" aria-hidden="true">Step 4 of 4</div>
        <h2 class="pw-step-title">Add your photo</h2>
        <p class="pw-step-sub"></p>
        <div
          class="pw-avatar-preview"
          [attr.aria-label]="
            'Profile preview for ' +
            (profile.preferredName || profile.firstName) +
            ' ' +
            profile.lastName
          "
        >
          <div class="pw-avatar-circle" aria-hidden="true">
            <app-user-avatar
              [imageUrl]="profile.photoUrl || null"
              [name]="(profile.preferredName || profile.firstName) + ' ' + profile.lastName"
            />
          </div>
          <div class="pw-avatar-info">
            <div class="pw-avatar-name">
              {{ profile.preferredName || profile.firstName }} {{ profile.lastName }}
            </div>
            <div class="pw-avatar-career">
              Future {{ careers.find((c) => c.id === profile.careerId)?.label ?? 'Professional' }}
            </div>
            <div class="pw-avatar-note"></div>
          </div>
        </div>
        <button class="pw-upload-btn" (click)="triggerUpload()" aria-label="Upload a profile photo">
          + Upload a photo
        </button>
        <input
          type="file"
          accept="image/*"
          id="photoInput"
          style="display: none"
          (change)="onPhotoSelected($event)"
          aria-label="Choose a profile photo"
        />
      </div>
    </div>

    <!-- Footer -->
    <div class="pw-footer">
      <button
        class="pw-back-btn"
        [style.visibility]="currentStep === 1 ? 'hidden' : 'visible'"
        (click)="prev()"
        aria-label="Go to previous step"
      >
        ← Back
      </button>

      <span class="pw-step-counter" aria-live="polite" aria-atomic="true">
        Step {{ currentStep }} of {{ steps.length }}
      </span>

      <button
        class="pw-next-btn"
        [class.finish]="currentStep === steps.length"
        (click)="next()"
        [attr.aria-label]="
          currentStep === steps.length ? 'Finish profile setup' : 'Continue to next step'
        "
      >
        {{ currentStep === steps.length ? 'Finish setup ✓' : 'Continue →' }}
      </button>
    </div>
  </div>
</div>
